<template>
  <div class="partners">

    <div class="partners-heading block-heading-font-style">{{ partnerText.heading }}</div>
    <div class="partners-subheading block-subheading-font-style">{{ partnerText.subheading }}</div>

    <span class="partner-logos">
      <img v-for="partner in partnerList" :src="getImgUrl(partner)" alt="partner">
    </span>

  </div>
</template>

<script>

// Upload more images here
// https://console.aws.amazon.com/s3/buckets/mikmak/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/?region=us-east-1&tab=overview

export default {
  mounted() {
    if (!window.sr) window.sr = ScrollReveal()
    window.sr.reveal('.partners', { delay: 250, duration: 500 })
  },
  methods: {
    getImgUrl(brand) {
      return `//mikmak.s3.amazonaws.com/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/${brand}.png`
    }
  },
  computed: {
    partnerText() {
      return this.$store.state.partnerText
    },
    partnerList() {
      return this.$store.state.partnerList
    }
  },
  watch: {}
}
</script>

<style scoped>

  .partners {
    display: block;
    background: #f1f1f169;
    padding: 24px 0;
  }

  .partner-logos {
    display: block;
    text-align: center;
    width: 90%;
    margin: 0 auto;
    text-align: center;
    margin-top: 24px;
  }

  @media only screen and (max-width: 800px) {
    .partner-logos {
      width: 100%;
    }
  }

  .partner-logos img {
    display: inline-block;
    width: 124px;
    margin: 12px 24px;
    opacity: 0.5;
  }

  @media only screen and (max-width: 800px) {
    .partner-logos img {
      display: inline-block;
      width: 70px;
      margin: 0 12px;
    }
  }

  @media only screen and (max-width: 450px) {
    .partner-logos img {
      display: inline-block;
      width: 40px;
      margin: 8px;
    }
  }

</style>



// WEBPACK FOOTER //
// Partners.vue?628cc88f